import * as React from 'react';
import { Button } from "primereact/button";

const alphaEnIndex = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
const alphaBgIndex = ['А', 'Б', 'В', 'Г', 'Д', 'Е', 'Ж', 'З', 'И', 'Й', 'К', 'Л', 'М', 'Н', 'О', 'П', 'Р', 'С', 'Т', 'У', 'Ф', 'Х', 'Ц', 'Ч', 'Ш', 'Щ', 'Ъ', 'Ю', 'Я'];

const alphabeticalFilter = (props) => {
  const enFilter = props.filters.indexOf('en') > -1 ?
    alphaEnIndex.map(letter => {
      return <Button
        key={letter}
        className="p-button-raised"
        style={{ marginRight: "5px", marginBottom: "5px" }}
        label={letter}
        onClick={() => props.handleAlphaIndexChange(letter)}
      />
    }) : null;

  const bgFilter = props.filters.indexOf('bg') > -1 ?
    alphaBgIndex.map(letter => {
      return <Button
        key={letter}
        className="p-button-raised"
        style={{ marginRight: "5px", marginBottom: "5px" }}
        label={letter}
        onClick={() => props.handleAlphaIndexChange(letter)}
      />
    }) : null;

  return (
    <div>
      {props.filters.indexOf('en') > -1 ?
        <div style={{ marginBottom: '5px' }}>
          {enFilter}
        </div> : null}
      {props.filters.indexOf('bg') > -1 ?
        <div style={{ marginBottom: '5px' }}>
          {bgFilter}
        </div> : null}
    </div>
  )
}

export default alphabeticalFilter;